import SEO from "../components/common/SEO";
import PageHero from "../components/common/PageHero";
import { StaggerGroup } from "../components/common/Reveal";
import SolutionCard from "../components/cards/SolutionCard";
import CTASection from "../components/common/CTASection";
import { solutions } from "../data/solutions";

export default function Solutions() {
  return (
    <>
      <SEO
        title="Solutions"
        description="AI transformation, data modernization, cloud transformation, application modernization, digital engineering and workforce transformation solutions."
        path="/solutions"
      />
      <PageHero
        eyebrow="Solutions"
        title="Solutions Designed Around Your Business"
        subtitle="Outcome-focused solutions that combine technology and talent to solve your most important challenges."
        neural
      />
      <section className="px-6 pb-8">
        <StaggerGroup className="mx-auto grid max-w-7xl gap-6 lg:grid-cols-2" stagger={0.08}>
          {solutions.map((s) => (
            <SolutionCard key={s.slug} solution={s} />
          ))}
        </StaggerGroup>
      </section>
      <CTASection />
    </>
  );
}
